 /*
  * 配置编译环境和线上环境之间的切换
  * apiUrl: 域名地址
  * 本地运行:npm run dev
  * 测试环境打包，运行：cnpm run build--test
  *生产环境打包，运行：cnpm run build--prod
  *createdBy Lijimin 2020-11-2
  */
  var apiUrl='';
  var frontEndUrl="https://test.multcloud.com";
  var previewApiwUrl='';//预览的url
  var loginRedirectUrl='';//登录重定向url
  var addCloudRedirectUrl='';//添加云盘重定向url
  var addFromEmailTransRedirectUrl='';//添加云盘邮件传输页面重定向url
  var sharePageUrl='';//用于分享界面
  var sharePageApiUrl='';
  var signPageApiUrl='';
  var mcIndexUrl='';
  var oldVersionUrl='';//老版本的url
  var nowNewUrl='';//当前新版本的url
  var addCloudUrl = '';
  var inviteFriendsUrl = '';
  var liteUrl = '';

 var user = "";
 var source = null;
 var drives = null;
 var KEYVALUE;
 var ENCRYPT_KEYVALUE;
 if(process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'development') {
    KEYVALUE= "==QkJi2uhJfnKwS3BfTC4aIL";
    ENCRYPT_KEYVALUE= "KXrDPHUkQSMKhklkKHHP+Q==";
 }else {
    KEYVALUE= "==AFqs2HcvvHcJL1Jpb8F1sN";
    ENCRYPT_KEYVALUE= "Ns1F8bpJ1LJcHvvcH2sqFA==";
}
 var KEY = KEYVALUE.split("").reverse().join("");
 var ENCRYPT_KEY = ENCRYPT_KEYVALUE;
 const officeAppUrl = "https://view.officeapps.live.com/op/view.aspx?src=";//无论在哪个环境下，office预览文件的环境不变
 const googleDriveViewUrl = "https://drive.google.com/viewerng/viewer?embedded=true&url=";//无论在哪个环境下，谷歌预览文件的环境不变
 const officeViewUrl = "https://view.officeapps.live.com/op/embed.aspx?src=";//无论在哪个环境下，office预览文件的环境不变
 const activityEndedTimer = "2125-11-30 23:59:59";//活动截止时间
//  var uploadUrl="http://localhost:80";
 var uploadUrl="https://test.multcloud.com/api";
 var cbApiUrl="https://rest.cleverbridge.com";
 //如果此环境是开发环境，可以根据本地实际情况进行更改
 if (process.env.NODE_ENV == 'development') {
        liteUrl="http://localhost:8888";
        nowNewUrl="http://localhost:8080";
        oldVersionUrl = "http://localhost/api";
        previewApiwUrl = "http://localhost/api";
        // apiUrl = "http://localhost:80";
        frontEndUrl="http://localhost:8080";
        sharePageApiUrl="http://localhost:80";
        apiUrl = "/api";
        uploadUrl="http://localhost/api";
        apiUrl = "http://localhost/api";
//如果此环境是测试环境
 }else if(process.env.NODE_ENV == 'testing'){
        liteUrl="https://test.multcloud.com";
        nowNewUrl="https://test.multcloud.com";
        oldVersionUrl = "https://www.multcloud.com";
        previewApiwUrl = "https://test.multcloud.com/api";
       // apiUrl = "http://localhost:8080";
        //uploadUrl = "http://localhost:8080";
        uploadUrl="https://test.multcloud.com/api";
        apiUrl = "https://test.multcloud.com/api";
        frontEndUrl="https://test.multcloud.com";
        sharePageApiUrl="https://test.multcloud.com";
//如果此环境是生产环境
 }else if(process.env.NODE_ENV == 'production'){
    liteUrl="https://lite.multcloud.com";
    nowNewUrl="https://app.multcloud.com";
    oldVersionUrl = "https://www.multcloud.com";
    previewApiwUrl = "https://www.multcloud.com/api";
    apiUrl = "https://app.multcloud.com/api";
    uploadUrl="https://app.multcloud.com/api";
    frontEndUrl="https://www.multcloud.com";
    sharePageApiUrl="https://share.multcloud.link";
    signPageApiUrl="https://sign.multcloud.com";
 }
 
 mcIndexUrl = oldVersionUrl+"/index.jsp";
 loginRedirectUrl = nowNewUrl+'/login_callback.html';
 addCloudRedirectUrl = nowNewUrl+'/static/add_cloud_callback.html';
 addFromEmailTransRedirectUrl = nowNewUrl+'/static/add_cloud_email_transfer_callback.html';
 //跳转到新页面云盘选择界面
 addCloudUrl = nowNewUrl+'/mc_project/add_cloud';
//邀请朋友活动注册链接
inviteFriendsUrl = "/inviteFriendsSign.html?inviteId=";
sharePageUrl=sharePageApiUrl+"/share/";

const zipList = ['000', '001', '7z', 'ace', 'ain', 'alz', 'apz', 'ar', 'arc', 'ari', 'arj', 'axx', 'bh', 'bhx', 'boo', 'bz', 'bza', 'bz2', 'cab', 'car',
    'cbr', 'cbz', 'cp9', 'cpgz', 'cpt', 'dar', 'dd', 'dgc', 'efw', 'f', 'gca', 'gz', 'ha', 'hbc', 'hbc2', 'hbe', 'hki', 'hki1', 'hki2', 'hki3', 'hpk', 'hyp',
    'ice', 'imp', 'ipk', 'ish', 'jar', 'jgz', 'jic', 'kgb', 'kz', 'lbr', 'lha', 'lnx', 'lqr', 'lz4', 'lzh', 'lzm', 'lzma', 'lzo', 'lzx', 'md', 'mint', 'mou',
    'mpkg', 'mzp', 'nz', 'p7m', 'package', 'pae', 'pak', 'paq6', 'paq7', 'paq8', 'par', 'par2', 'pbi', 'pcv', 'pea', 'pf', 'pim', 'pit', 'piz', 'puz', 'pwa',
    'qda', 'r00', 'r01', 'r02', 'r03', 'rar', 'rk', 'rpm', 'rte', 'rz', 'rzs', 's00', 's01', 's02', 's7z', 'sar', 'sdn', 'sea', 'sfs', 'sh', 'shar', 'shk', 'shr',
    'sit', 'sitx', 'spt', 'sqx', 'sqz', 'tar', 'taz', 'tbz', 'tbz2', 'tgz', 'tlz', 'tlz4', 'txz', 'uc2', 'uha', 'uue', 'wot', 'xef', 'xx', 'xxe', 'xz', 'y', 'yz',
    'yz1', 'z', 'zap', 'zip', 'zipx', 'zix', 'zoo', 'zz'
];
const wordList = ['doc', 'docm', 'docx', 'dot', 'odt', 'wps'];
const exceList = ['xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx', 'xps', 'csv', 'dbf', 'dif', 'ods', 'prn', 'slK', 'xla', 'xlam'];
const pptList = ['ppt', 'pptm', 'pptx', 'odp', 'pot', 'potm', 'potx', 'ppa', 'ppam', 'pps', 'ppsm', 'ppsx'];
const htmlList = ['xhtml', 'html', 'html', 'mht', 'mhtml'];
const imgList = ['bmp', 'rle', 'dib', 'jpg', 'jpeg', 'jpe', 'jpf', 'jpx', 'jp2', 'j2c', 'j2K', 'jpc', 'jps', 'png', 'tif', 'tiff', 'pbm', 'pgm',
    'ppm', 'pnm', 'pfm', 'pam', 'mpo', 'gif', 'hevc', 'heif'
];
const rawList = ['raw', 'dng', 'cr2', 'arw', 'dcr', 'mrw', 'nef', 'orf', 'pef', 'x3f'];
const cdaList = ['cda', 'wav', 'aiff', 'mp3', 'mid', 'wma', 'vqf', 'ogg', 'arm', 'ape', 'flac', 'aac'];
const movLsit = ['mpeg', 'mpg', 'dat', 'avi', 'mov', 'asf', 'wmv', 'navi', '3gp', 'ra', 'rm', 'rmx', 'mkv', 'flv', 'f4v', 'rmvb', 'webm', 'qsv', 'mp4'];
const pdfList = ['pdf', 'pdp'];
const psdList = ['psd', 'pdd', 'psdt'];
const aiList = ['ai', 'esp'];
const aeList = ['aep', 'aepx'];
const cadList = ['dwg', 'dxf', 'dwt', 'wimf'];
const ttfList = ['eot', 'otf', 'fon', 'font', 'ttf', 'ttc', 'woff', 'woff2'];
const isoList = ['iso', 'img', 'bin', 'nrg', 'vcd', 'cif', 'fcd', 'ccd', 'c2d', 'dfi', 'tao', 'dao', 'cue'];
//添加云盘界面使用判断
//只添加云盘名的云盘
const specialDrives = ["mega", "ftp", "yandex", "mediafire", "webDav", "cloudMe", "amazonS3","wasabi","iDrivee2", "ownCloud", "mySQL", "egnyte", "aDrive", "Icedrive","hiDrive", "sugarSync", "WEBDE", "myDrive", "cubby", "backblaze", 'iCloudPhotos', 'iCloudDrive'];
//添加云盘为名称，邮箱，密码的云盘
const threeParamDrives = ["mega", "mediafire", "aDrive","Icedrive", "sugarSync", "WEBDE", "cubby"];
//添加云盘为名称，用户名，密码的云盘
const userNameParamDrives = ['myDrive', 'yandex', 'hiDrive', 'cloudMe'];
const googlePhotos = ['/', '/albums', '/sharing'];
//打开云盘属性，没有提示信息的云盘
const unTips = ['mega', 'dropbox', 'oneDrive','oneDriveV2', 'oneDrive4Business','sharePointOnline','dropbox4Business', 'pCloud', 'amazonS3','wasabi', 'ownCloud', 'egnyte', 'putio', 'sugarSync', 'egnyte', 'iCloudPhotos', 'iCloudDrive','iDrivee2','fourShared'];
//邮件云盘
const emailClouds = ['gmail','outlook'];
//系统中文件名称不支持的特殊字符
const pattern = new RegExp("[\\\\?*|:\"<>/]");
const patternDriveName = new RegExp("[\\\\&?*|:\"<>/]");
const patternUserName = new RegExp("[\\\\@?.~'|\"<>/]");
//用于校验添加云盘时候的邮箱
const emailpattern=/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const cLanguageArr = ['japanese', 'traditionalChinese', 'chinese'];
const cloudCategories = [];
//百度云盘只读文件目录
const baiDuReadOnlyArrAll = ['/【图片】','/【种子】','/【其他】', '/【应用】','/【文档】', '/【视频】', '/【音乐】', '/我的云盘'];
//不支持同云盘复制的云盘
const notSupportCopy=['mega','googlePhotos','FTP','pCloud','hubiC','mySQL','putio','backblaze','google_drive','iCloudDrive'];
//不支持同云盘剪切的云盘
const notSupportCut=['googlePhotos','FTP','flickr','evernote','hubiC','amazonS3','mySQL','backblaze','iCloudDrive'];
//显示支持即时同步的云盘
const supportRealTimeDrives=['box','google_drive','gSuite','oneDrive','oneDriveV2','oneDrive4Business','dropbox4Business','dropbox'];
//活动用loginType集合
const activeLoginTypeList = ['a202301', 'a202302', 'xd-wpc', 'xd-gtc', 'xd-cmg', 'zyp-swo', 'xd-god', 'xd-tip', 'xd-p2d', 'qd-wys-chip', 'xd-dpf', 'xd-rrl', 'xd-ade', 
    'xd-dst', 'xd-sll', 'xd-sel', 'xd-tek', 'xd-wcw', 'xd-kpc', 'xd-get', 'xd-moo', 'xd-sho', 'xd-pcg', 'xd-vnz', 'xd-dow', 'xd-ykc', 'xd-sof', 'xd-pro','xd-tic', 'xd-stw', 
    'xd-fah', 'xd-gea', 'xd-win', 'xd-use', 'xd-rot', 'xd-pon', 'xd-eli', 'xd-ite', 'xd-sha', 'xd-doc', 'xd-sam', 'xd-gpc', 'xd-ngo', 'xd-cpb', 'xd-omo', 'xd-pay', 'xd-ivo', 
    'xd-one', 'xd-nto', 'xd-oxy', 'xd-ctw', 'p-xmas'];
const activeCartIdList = ['a202302', 'giveAway500', 'giveAway200'];
const active500GBList = ['a202302', 'xd-gtc', 'xd-cmg', 'zyp-swo', 'xd-ite', 'xd-sha', 'xd-doc', 'xd-sam', 'xd-gpc', 'xd-ngo', 'xd-cpb', 'xd-omo', 'xd-pay', 'xd-ivo', 'xd-one', 'xd-oxy', 'p-xmas'];
const active200GBList = ['xd-god', 'xd-tip', 'xd-p2d', 'xd-wpc', 'qd-wys-chip', 'xd-dpf', 'xd-rrl', 'xd-ade', 'xd-dst', 'xd-sll', 'xd-sel', 'xd-tek', 'xd-wcw', 'xd-kpc', 'xd-get', 'xd-moo', 'xd-sho', 
    'xd-pcg', 'xd-vnz', 'xd-dow', 'xd-ykc', 'xd-sof', 'xd-pro','xd-tic', 'xd-stw', 'xd-fah', 'xd-gea', 'xd-win', 'xd-use', 'xd-rot', 'xd-pon', 'xd-eli', 'xd-nto', 'xd-ctw'];
//注册渠道集合
const channelTypeList = ['free-xd-levelupId-2024'];
//第三方登录类型集合
const thirdLoginList = ['google','google_drive','apple','facebook',];
const cbLinkUrl='https://order.multcloud.com';
const syncType=2;//同步任务类型
const transferType=1;//传输任务类型
const newPay=true;//标识新的支付系统是否上线
const twoStepverification=true;
const flashSaledName='family-day';//活动标识
const freeSaledName='family-day-free10GB';//免费赠送活动标识
export default{
    KEY,
    ENCRYPT_KEY,
    user,
    source,
    apiUrl,
    previewApiwUrl,
    zipList,
    wordList,
    exceList,
    pptList,
    htmlList,
    imgList,
    rawList,
    cdaList,
    movLsit,
    pdfList,
    psdList,
    aiList,
    aeList,
    cadList,
    ttfList,
    isoList,
    officeAppUrl,
    officeViewUrl,
    googleDriveViewUrl,
    drives,
    googlePhotos,
    loginRedirectUrl,
    addCloudRedirectUrl,
    addFromEmailTransRedirectUrl,
    specialDrives,
    unTips,
    threeParamDrives,
    userNameParamDrives,
    emailClouds,
    pattern,
    oldVersionUrl,
    patternDriveName,
    cloudCategories,
    cLanguageArr,
    baiDuReadOnlyArrAll,
    patternUserName,
    mcIndexUrl,
    sharePageUrl,
    sharePageApiUrl,
    emailpattern,
    notSupportCopy,
    addCloudUrl,
    syncType,
    transferType,
    notSupportCut,
    supportRealTimeDrives,
    activeLoginTypeList,
    activeCartIdList,
    active500GBList,
    active200GBList,
    nowNewUrl,
    channelTypeList,
    thirdLoginList,
    cbLinkUrl,
    newPay,
    inviteFriendsUrl,
    uploadUrl,
    liteUrl,
    cbApiUrl,
    twoStepverification,
    frontEndUrl,
    activityEndedTimer,
    flashSaledName,
    freeSaledName,
}



// WEBPACK FOOTER //
// ./src/js/constant.js